export default __webpack_public_path__ + "static/media/logo.021afdb7.svg";